import { api } from 'utility';
import { getGrantsUrl, getDeleteGrantUrl, getUserGrantsServiceUrl } from 'URLs';
// Cards
export function getGrants(params) {
  return api.get(getGrantsUrl(), { params }).then((res) => res.data);
}
export function deleteGrant(id) {
  return api.delete(getDeleteGrantUrl(id)).then((res) => res.data);
}
export function postUserGrant(id, body) {
  return api.post(getUserGrantsServiceUrl(id), body).then((res) => res.data);
}

export function deleteUserGrant(id, params) {
  return api.delete(getUserGrantsServiceUrl(id), { params }).then((res) => res.data);
}

export default {
  getGrants,
  deleteGrant,
  postUserGrant,
  deleteUserGrant,
};
